<template>
  <div class="cotent_detail">
    <div class="content_top">
      <img :src="product.dingimg" alt="" class="w100" />
      <!-- <h3>Products</h3> -->
    </div>
    <div class="content_center_de">
      <div class="container">
        <div class="detail_top_box">
          <div class="left_text">
            <h3 class="custom-title">{{ product.product_info.title }}</h3>
            <div class="product_info pc">
              <p class="atitle">{{ product.product_info.atitle }}</p>
              <p>
                <span class="custom-title">Overview:</span>
              </p>
              <p>
                {{ product.product_info.overview }}
              </p>
              <a href="#content_bottom" class="btn_content_bottom">
                SEND EMAIL TO US
                <img src="@/assets/images/detail/right.png" alt="" class="" />
              </a>
            </div>
          </div>
          <div class="right_img">
            <div class="swiper-container mySwiper2">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in product.pic_list"
                  :key="index"
                >
                  <img :src="item.show_img" class="w100 top-img" />
                </div>
              </div>
            </div>
            <div class="swiper-box">
              <div thumbsSlider="" class="swiper-container mySwiper">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(item, index) in product.pic_list"
                    :key="index"
                  >
                    <img :src="item.show_img" class="w100" />
                  </div>
                </div>
              </div>
              <div class="swiper-button-next swiper-button-next3"></div>
              <div class="swiper-button-prev swiper-button-prev3"></div>
            </div>
          </div>
          <div class="left_text mobile">
            <!-- <h3 class="custom-title">{{ product.product_info.title }}</h3> -->
            <div class="product_info mobile">
              <p
                class="atitle"
                style="margin-top: 10px;font-size: 12px;line-height: 18px;"
              >
                {{ product.product_info.atitle }}
              </p>
              <p>
                <span style="font-size: 12px;line-height: 18px;">
                  Overview:
                </span>
              </p>
              <p style="font-size: 12px;line-height: 18px;">
                {{ product.product_info.overview }}
              </p>
              <a href="#content_bottom" class="btn_content_bottom">
                SEND EMAIL TO US
                <img src="@/assets/images/detail/right.png" alt="" class="" />
              </a>
            </div>
          </div>
        </div>

        <h5
          v-if="
            product.product_info.content != '' &&
              productName != 'Abrasion-Resistant-Steel-Plate'
          "
        >
          Specification:
        </h5>
        <h5
          v-if="
            product.product_info.content != '' &&
              productName == 'Abrasion-Resistant-Steel-Plate'
          "
        >
          Element:
        </h5>
        <div
          style="display:flex;"
          v-if="productName != 'Wear-plate-welding-wire'"
        >
          <img
            :src="product.product_info.sizepic"
            v-if="product.product_info.sizepic.length > 10"
            class="sizepic"
          />
          <div
            v-if="product.product_info.content != ''"
            style="flex:1;width: 100%;overflow-y: auto;"
            class="table_container"
            v-html="product.product_info.content"
          ></div>
        </div>
        <div
          style="display:flex;margin-top: 3vw;"
          v-if="productName == 'Wear-Resistant-Casting'"
        >
          <img
            :src="product1.product_info.sizepic"
            v-if="product1.product_info.sizepic.length > 10"
            class="sizepic"
          />
          <div
            v-if="product1.product_info.content != ''"
            style="flex:1;"
            v-html="product1.product_info.content"
          ></div>
        </div>
        <div
          class=""
          v-if="productName == 'Industrial-roller-rebuilding-welding-wire'"
        >
          <p>
            <b>MillAid welding wires</b>
          </p>
          <p>
            The availability of processing equipment is the main concern of
            every plant, every mill is a continuous process plant. One process
            depends on the other, in cement and power industries, Vertical
            Roller Mills are used for grinding various raw material, crushing
            material into fine particles and feeding it for further processing,
            the VRM parts undertake severe wear caused during grinding and
            crushing, once there is wear problem, it can influence the most
            expensive part of the plant. A worn VRM roller profile also reduces
            grinding efficiency, increasing energy demands further. To reduce
            the machine downtime cost, we have developed the MillAid welding
            wires. It is a comprehensive solution for Mill wear problem. For
            more detailed information, please contact your technical support.
          </p>
          <p>
            <b>RPExtend welding wires</b>
          </p>
          <p>
            In cement and steel industries, roller presses is used for grinding
            raw materials, crushing minerals, materials between the rollers is
            crushed under pressure, causing abrasion and impact wear to the
            rollers, in order to increase the production efficiency of roller
            press, reduce down time, reduce roller damage, we have developed the
            RPExtend welding wires to build-up and hardfacing the worn rollers.

            <br />
            We have specialist know-how and technology for the repairs on site,
            it will avoid time and handling costs for the removal and
            re-installation of mill table and rollers. <br />
            We provide service for old roller refurbishment and new roller
            hardfacing. On-site and in house repairs are both available. <br />
            For more detailed information, please contact your technical
            support.
          </p>
        </div>
        <div
          class="tshu_img_box"
          v-if="productName == 'Wear-plate-welding-wire'"
        >
          <img
            :src="item.show_img"
            v-for="(item, index) in tshu_img"
            v-key="index"
            alt=""
            class="tshu_img"
          />
        </div>
        <h5 v-if="product.product_info.typicalcontent != ''">
          Typical properties:
        </h5>
        <p v-if="product.product_info.typicalcontent != ''">
          Weld overlay composition:
        </p>
        <div
          class="custom-table"
          v-if="product.product_info.typicalcontent != ''"
          v-html="product.product_info.typicalcontent"
        ></div>
        <p class="note" v-if="product.product_info.typical_bulk != ''">
          Note: The content varies in different plate thickness.
        </p>
        <ul class="Bulk_box">
          <li v-if="product.product_info.typical_bulk != ''">
            <span>Bulk Hardness: </span>{{ product.product_info.typical_bulk }}
          </li>
          <li v-if="product.product_info.typical_abrasion != ''">
            <span>Abrasion Test result: </span
            >{{ product.product_info.typical_abrasion }}
          </li>
        </ul>
        <div
          class="surfacepic_box"
          v-if="product.product_info.surfacepic != ''"
        >
          <div class="surfacepic">
            <h5>Surface Finish:</h5>
            <img :src="product.product_info.surfacepic" alt="" class="w100" />
          </div>
          <div class="X2001pic_box">
            <h5>X200 metallographic Structure:</h5>
            <div class="X2001pic">
              <img :src="product.product_info.X2001pic" alt="" />
              <img :src="product.product_info.X2001pic2" alt="" />
            </div>
          </div>
        </div>
        <h5 v-if="product.product_info.cat_id == 1">Fabrication:</h5>
        <div v-if="product.product_info.cat_id == 1&&productName != 'hs-f-smooth-surface-chromium-carbide-overlay-wear-plates-produc'" class="Fabrication_box">
          <div
            class="fabrication"
            v-for="(item, index) in fabrication.slice(0,4)"
            :key="index"
          >
            <img :src="item.show_img" alt="" class="w100" />
            <p>{{ item.show_name }}</p>
          </div>
        </div>
        <div v-if="product.product_info.cat_id == 1&&productName == 'hs-f-smooth-surface-chromium-carbide-overlay-wear-plates-produc'" class="Fabrication_box">
          <div
            class="fabrication"
            v-for="(item, index) in fabrication.slice(4,8)"
            :key="index"
          >
            <img :src="item.show_img" alt="" class="w100" />
            <p>{{ item.show_name }}</p>
          </div>
        </div>
        <h5 v-if="product.product_info.cat_id == 1">Main benefits:</h5>
        <ul class="catid1list" v-if="product.product_info.cat_id == 1">
          <li>
            <img src="@/assets/images/detail/icon_1.png" alt="" />
            <p>{{ product.product_info.benefits1 }}</p>
          </li>
          <li>
            <img src="@/assets/images/detail/icon_2.png" alt="" />
            <p>{{ product.product_info.benefits2 }}</p>
          </li>
          <li>
            <img src="@/assets/images/detail/icon_3.png" alt="" />
            <p>{{ product.product_info.benefits3 }}</p>
          </li>
          <li>
            <img src="@/assets/images/detail/icon_4.png" alt="" />
            <p>{{ product.product_info.benefits4 }}</p>
          </li>
        </ul>
        <h5
          v-if="
            product.product_info.cat_id == 1 ||
              productName == 'Abrasion-Resistant-Steel-Plate'
          "
        >
          Applications:
        </h5>
        <!-- <p v-if="product.product_info.cat_id==1">Weld overlay composition:</p> -->
        <div
          v-html="product.product_info.applicationscontent"
          class="custom-table"
        ></div>

        <!-- <img v-if="product.product_info.cat_id==1" src="@/assets/images/detail/table.jpg" alt="" class="w100"> -->
        <h5 style="padding: 0;"></h5>
      </div>
    </div>
    <div class="content_center2" v-if="productName == 'Overlay-Wear-Pipe'">
      <div class="container">
        <h3 class="custom-title">Features</h3>
        <ul>
          <li>
            Advanced hardfacing process
          </li>
          <li>
            Superior wear resistance
          </li>
          <li>Good resistant to impact</li>
          <li>Excellent hardness</li>
          <li>Lower maintenance cost</li>
          <li>Long service life</li>
          <li>Adaptable to various configurations</li>
          <li>Available in Internal or External hardface</li>
          <li>Wide range of sizes for most applications</li>
          <li>Easy installation & field repair</li>
          <li>Strong connection performance</li>
          <li>Good processing performance</li>
        </ul>
      </div>
    </div>
    <div class="content_center_de" v-if="productName == 'Overlay-Wear-Pipe'">
      <div class="container">
        <h5>Specification:</h5>
        <p>
          Wide range of base pipe thickness and overlay thickness options are
          available
        </p>
        <div class="bottom-p">
          <div>
            <span style="color: #ad1f24;">Length</span>
            can be up to 40 feet
          </div>
          <div>
            <span style="color: #ad1f24;">Diameter</span>
            can be as small as 3 inches
          </div>
        </div>
        <h5 style="padding: 0;"></h5>
        <div class="detail45_box">
          <div class="detail45_left_pc pc">
            <div class="detail45_bottom">
              <h6 class="custom-title">End Attachment Options:</h6>
              <div class="pc">
                <p class="pc">
                  Many options are available for end attachments: <br />
                  Standard Flanges (i.e. 150#, 300#, and 600#)
                </p>
                <p style="margin-bottom: 4px;" class="mobile">
                  Many options are available for end attachments: Standard
                  Flanges (i.e. 150#, 300#, and 600#)
                </p>
                <p style="margin-bottom: 4px;">
                  Weld Rings
                </p>
                <p>
                  Victaulic end, etc.
                </p>
              </div>
            </div>
            <img
              src="@/assets/images/detail/detail45_1.jpg"
              alt=""
              class="detail45_1"
            />
          </div>
          <div class="detail45_left mobile">
            <h6 class="custom-title">End Attachment Options:</h6>
            <div class="detail45_bottom ">
              <div>
                <p class="pc">
                  Many options are available for end attachments: <br />
                  Standard Flanges (i.e. 150#, 300#, and 600#)
                </p>
                <p style="margin-bottom: 4px;" class="mobile">
                  Many options are available for end attachments: Standard
                  Flanges (i.e. 150#, 300#, and 600#)
                </p>
                <p style="margin-bottom: 4px;">
                  Weld Rings
                </p>
                <p>
                  Victaulic end, etc.
                </p>
              </div>
              <img
                src="@/assets/images/detail/detail45_1.jpg"
                alt=""
                class="detail45_1"
              />
            </div>
          </div>
        </div>
        <h5>Application:</h5>
        <p style="margin-bottom: 4px;">
          Overlay wear pipe has been widely used in various industries including
          steel, cement, concrete, mining, metallurgy, power generation,
          aggregate, glass, pulp, paper, chemical and other industries.
        </p>
        <p style="margin-bottom: 4px;">
          It is the preferred choice in the conveying of materials such as:
          aggregate, ash, coal, sand, cement, stone, gravel, limestone,
          magnetite, mill scale, mine tailing, ores, raw kiln feed, slurry, mud,
          slag, etc.
        </p>
        <h5 style="padding: 0;"></h5>
      </div>
    </div>
    <div class="content_bottom_a" id="content_bottom">
      <div class="container">
        <h3 class="custom-title">Enquiry Form</h3>
        <ul class="input_box">
          <li>
            <p>Name<span>*</span></p>
            <input type="text" v-model="name" />
          </li>
          <li>
            <p>Email<span>*</span></p>
            <input type="text" v-model="email" />
          </li>
          <li>
            <p>Phone<span>*</span></p>
            <input type="text" v-model="phone" />
          </li>
          <li>
            <p>Company<span>*</span></p>
            <input type="text" v-model="company" />
          </li>
        </ul>
        <div class="checkbox_box">
          <p>Area/s of Interest</p>
          <ul>
            <li>
              <input
                type="checkbox"
                value="CCO plate"
                v-model.number="interest"
                name="interest"
                id=""
              />
              CCO plate
            </li>
            <!-- <li>
							<input type="checkbox" value="AR steel plate" v-model.number="interest" name="interest" id="" />
							 AR steel plate</li> -->
            <li>
              <input
                type="checkbox"
                value="Bimetal Casting CWI"
                v-model.number="interest"
                name="interest"
                id=""
              />
              Overlay Wear Pipe
            </li>
            <!-- <li><input type="checkbox" value="Ni Hard Liners& Blocks" v-model.number="interest" name="interest" id="" /> High Chromium White Cast Iron</li>
						<li><input type="checkbox" value="Wear resistant ceramics" v-model.number="interest" name="interest" id="" /> Wear resistant ceramics</li>
						 -->
            <li>
              <input
                type="checkbox"
                value="Welding wire"
                v-model.number="interest"
                name="interest"
                id=""
              />
              Welding wire
            </li>
          </ul>
        </div>
        <div class="message_box">
          <p>Message</p>
          <textarea name="" v-model="message" id="message"></textarea>
        </div>
        <div class="button_submit" @click="submitinfo()">
          Send
        </div>
        <h3 v-if="product.product_related.length > 0" class="custom-title">
          Related Products
        </h3>
      </div>
    </div>
    <div
      class="pro_box_a"
      v-if="
        productName != 'Abrasion-Resistant-Steel-Plate' &&
          productName != 'Overlay-Wear-Pipe'
      "
    >
      <div class="container">
        <div class="swiper-container myswiper3">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              style="background: #efefef;"
              v-for="(item, index) in product.product_related"
              :key="index"
              :data-id="item.id"
            >
              <img class="w100" :src="item.image" alt="" />
              <p v-if="item.title">{{ item.title }}</p>
            </div>
          </div>
          <div class="swiper-pagination1"></div>
        </div>
      </div>
    </div>
    <div
      class="pro_box_a"
      v-if="
        productName == 'Abrasion-Resistant-Steel-Plate' ||
          productName == 'Overlay-Wear-Pipe'
      "
    >
      <div class="container">
        <h3 class="custom-title">Product Application</h3>
        <div
          class="swiper-container myswiper4"
          v-if="productName == 'Abrasion-Resistant-Steel-Plate'"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              style="background: #efefef;"
              v-for="(item, index) in lbList"
              :key="index"
            >
              <img class="w100" :src="item.show_img" alt="" />
              <p v-if="item.title">{{ item.title }}</p>
            </div>
          </div>
          <div class="swiper-pagination1"></div>
        </div>
        <div
          class="swiper-container myswiper4"
          v-if="productName == 'Overlay-Wear-Pipe'"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              style="background: #efefef;"
              v-for="(item, index) in lbList1"
              :key="index"
            >
              <img class="w100" :src="item.show_img" alt="" />
              <p v-if="item.title">{{ item.title }}</p>
            </div>
          </div>
          <div class="swiper-pagination1"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import axios from "axios";

export default {
  props: ["productName"],
  data() {
    return {
      id: "",
      fabrication: [],
      id: 1,
      name: "",
      productName: "",
      product: {
        // 初始化字段结构
        productName: "",
      },
      email: "",
      phone: "",
      company: "",
      interest: [],
      tshu_img: [],
      message: "",
      lbList: [],
      lbList1: [],
      product: {
        product_info: {
          id: "",
          cat_id: "",
          title: "",
          atitle: "",
          overview: "",
          specpic: "",
          sizepic: false,
          surfacepic: "",
          typicalpic: "",
          typical_bulk: "",
          typical_abrasion: "",
          content: "",
          X2001pic: "",
          X2001pic2: "",
          image: "",
          click: "",
          keywords: "",
          description: "",
          sort: "",
          add_time: "",
          shouye: "",
          ishot: "",
          isnew: "",
          time: {
            ymd: "",
            y: "",
            m: "",
            d: "",
          },
          cate_info: {
            cat_id: "",
            cat_name: "",
            parent_id: "",
            url: "",
          },
        },
        pic_list: [
          {
            id: "",
            show_name: "",
            show_link: "",
            show_img: "",
            show_text: "",
            show_text_array: [],
            sort: "",
          },
        ],
        product_related: [],
      },
      product1: {
        product_info: {
          id: "",
          cat_id: "",
          title: "",
          atitle: "",
          overview: "",
          specpic: "",
          sizepic: false,
          surfacepic: "",
          typicalpic: "",
          typical_bulk: "",
          typical_abrasion: "",
          content: "",
          X2001pic: "",
          X2001pic2: "",
          image: "",
          click: "",
          keywords: "",
          description: "",
          sort: "",
          add_time: "",
          shouye: "",
          ishot: "",
          isnew: "",
          time: {
            ymd: "",
            y: "",
            m: "",
            d: "",
          },
          cate_info: {
            cat_id: "",
            cat_name: "",
            parent_id: "",
            url: "",
          },
        },
        pic_list: [
          {
            id: "",
            show_name: "",
            show_link: "",
            show_img: "",
            show_text: "",
            show_text_array: [],
            sort: "",
          },
        ],
        product_related: [],
      },
    };
  },
  async created() {
    await this.fetchDetailData();
  },
  watch: {
    productName: {
      immediate: true,
      async handler(newId) {
        console.log(newId);
        this.productName = newId;
        await this.fetchDetailData();
      },
    },
  },
  methods: {
    golink(id) {
      console.log(id);
      for (var i = 0; i < this.product.product_related.length; i++) {
        if (id == this.product.product_related[i].id) {
          this.$router.push(this.product.product_related[i].linkurl);
        }
      }
    },
    handleSlideClick(event) {
      const dataId = event.currentTarget.dataset.id;
      console.log("点击获取的 data-id 值:", dataId);
    },
    async fetchDetailData() {
      var that = this;
      setTimeout(() => {
        axios({
          method: "post",
          url: `${this.$apiYf}/anlidetailapi.php`,
          data: {
            slug: that.productName,
          },
          headers: { "Content-Type": "multipart/form-data" },
        }).then((res) => {
          console.log(res);
          that.product = res.data;
          document.title = res.data.product_info.pagetitle;
          document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.product_info.keywords)
          document.querySelector('meta[name="description"]').setAttribute('content', res.data.product_info.description)
          this.$nextTick(() => {
            var swiper = new Swiper(".mySwiper", {
              // loop: true,
              spaceBetween: 10,
              slidesPerView: 3,
              freeMode: true,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              watchSlidesProgress: true,
            });
            var swiper2 = new Swiper(".mySwiper2", {
              spaceBetween: 10,

              thumbs: {
                swiper: swiper,
              },
            });
            let spaceBetween = 30;
            if (
              navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
              )
            ) {
              spaceBetween = 10;
            } else {
              spaceBetween = 30;
            }
            this.kvSwiper = new Swiper(".myswiper3", {
              loop: true,
              autoplay: {
                delay: 3000,
                disableOnInteraction: false,
              },
              pagination: {
                el: ".swiper-pagination1",
                clickable: true,
              },
              navigation: {
                nextEl: ".swiper-button-next1",
                prevEl: ".swiper-button-prev1",
                clickable: true,
              },
              centeredSlides: true,
              slidesPerView: 3,
              spaceBetween,
              speed: 500,
              roundLengths: true,
              observer: true,
              observeParents: true,
              observeSlideChildren: true,
              calculateHeight: true,
              on: {
                click: (e) => {
                  console.log(e);

                  let name = e.target.offsetParent.dataset.id;
                  if (name) {
                    that.golink(name);
                  }
                },
              },
            });
          });
          axios({
            method: "post",
            url: `${this.$apiYf}/indexlunboapi.php`,
            data: {
              cid: 19,
            },
            headers: { "Content-Type": "multipart/form-data" },
          }).then((res0) => {
            console.log(res0);
            that.lbList = res0.data.lunboinfo;
            that.$nextTick(() => {
              // that.kvSwiper = new Swiper(".myswiper4", {
              //   loop: true,
              //   autoplay: {
              //     delay: 3000,
              //     disableOnInteraction: false,
              //   },
              //   pagination: {
              //     el: ".swiper-pagination1",
              //     clickable: true,
              //   },
              //   navigation: {
              //     nextEl: ".swiper-button-next1",
              //     prevEl: ".swiper-button-prev1",
              //     clickable: true,
              //   },
              //   centeredSlides: true,
              //   slidesPerView: 3,
              //   spaceBetween: 30,
              //   speed: 500,
              //   roundLengths: true,
              //   observer: true,
              //   observeParents: true,
              //   observeSlideChildren: true,
              //   calculateHeight: true,
              //   on: {
              //     slideChangeTransitionEnd: function() {},
              //   },
              // });
            });
          });
          axios({
            method: "post",
            url: `${this.$apiYf}/indexlunboapi.php`,
            data: {
              cid: 20,
            },
            headers: { "Content-Type": "multipart/form-data" },
          }).then((res0) => {
            console.log(res0);
            that.lbList1 = res0.data.lunboinfo;
            let myswiper4Option = {};
            if (
              navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
              )
            ) {
              console.log("手机");
              myswiper4Option = {
                loop: true,
                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false,
                },
                pagination: {
                  el: ".swiper-pagination1",
                  clickable: true,
                },
                autoHeight: true,
                centeredSlides: true,
                slidesPerView: "auto",
                speed: 500,
                height: 200,
                spaceBetween: 10,
                roundLengths: true,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                calculateHeight: true,
              };
            } else {
              console.log("电脑");
              myswiper4Option = {
                loop: true,
                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false,
                },
                pagination: {
                  el: ".swiper-pagination1",
                  clickable: true,
                },
                navigation: {
                  nextEl: ".swiper-button-next1",
                  prevEl: ".swiper-button-prev1",
                  clickable: true,
                },
                centeredSlides: true,
                slidesPerView: 3,
                spaceBetween: 30,
                speed: 500,
                roundLengths: true,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                calculateHeight: true,
                on: {
                  slideChangeTransitionEnd: function() {},
                },
              };
            }
            that.$nextTick(() => {
              that.kvSwiper = new Swiper(".myswiper4", myswiper4Option);
              that.$forceUpdate();
              that.$emit("loaded");
            });
          });
        });
      }, 500);
    },
    submitinfo() {
      console.log(this.interest);
      if (this.email == "") {
        alert("Enter your email address");
      } else if (this.name == "") {
        alert("Enter your name");
      } else if (this.phone == "") {
        alert("Enter your phone");
      } else if (this.company == "") {
        alert("Enter your company");
      } else {
        console.log(this.useremail);
        axios({
          method: "post",
          url: `${this.$apiYf}/liuyanapi.php`,
          data: {
            email: this.email,
            name: this.name,
            phone: this.phone,
            company: this.company,
            interest: this.interest.toString(),
            message: this.message,
          },
          headers: { "Content-Type": "multipart/form-data" },
        }).then((res) => {
          console.log(res);
          alert(res.data.des);
        });
      }
    },
  },
  mounted() {
    var that = this;

    this.fetchDetailData();

    axios({
      method: "post",
      url: `${this.$apiYf}/indexlunboapi.php?cid=18`,

      headers: { "Content-Type": "multipart/form-data" },
    }).then((res) => {
      console.log(res);
      that.fabrication = res.data.lunboinfo;
    });
    axios({
      method: "post",
      url: `${this.$apiYf}/anlidetailapi.php`,
      data: {
        id: 28,
      },
      headers: { "Content-Type": "multipart/form-data" },
    }).then((res) => {
      console.log(res);
      that.product1 = res.data;
    });
    axios({
      method: "post",
      url: `${this.$apiYf}/indexlunboapi.php?cid=21`,
      data: {},
      headers: { "Content-Type": "multipart/form-data" },
    }).then((res) => {
      console.log(res);
      that.tshu_img = res.data.lunboinfo;
    });
  },
};
</script>

<style lang="scss">
.cotent_detail {
  @media (max-width: 768px) {
    .swiper-box {
      position: relative;
      width: 100%;
    }
    .myswiper4 {
      .swiper-slide {
        width: 60% !important;
      }
    }
    .swiper-button-next,
    .swiper-button-prev {
      border-radius: 0 !important;
      width: calc(23px) !important;
      height: calc(136px / 2) !important;
      height: 100% !important;
      top: 0 !important;
      right: 0 !important;
      background: #eeefef !important;
      margin-top: 0 !important;
    }
    .swiper-button-next3,
    .swiper-button-prev3 {
      background: #efefef;
      bottom: 0;
      top: 0;
      left: 0;
      width: 5%;
      height: 6.6vw;
      &.swiper-button-disabled {
        opacity: 1;
      }
      &::after {
        content: "prev";
        color: #666666;
        font-size: 12px;
        font-family: swiper-icons;
      }
    }
    .swiper-button-prev3 {
      left: 0 !important;

      &::after {
        font-size: 12px !important;
        top: 50% !important;
      }
    }
    .swiper-button-next3 {
      right: 0;
      left: auto;
      &::after {
        content: "next";
        font-size: 12px !important;
      }
    }
    p {
      font-size: 12px !important;
      line-height: 18px !important;
    }
    h5 {
      font-size: 21px !important;
    }
    .container {
      width: 90%;
    }
    .content_top {
      img {
      }
    }
    .table_container {
      width: 100%;
      overflow-y: auto;
      table {
        width: 100% !important;

        span {
          display: inline-block;
          width: 100%;
          text-align: center;
          font-size: 12px !important;
          display: inline-block !important;
          text-align: center !important;
        }
      }
    }
  }
  .content_center2 {
    width: 100%;
    padding-bottom: 7vw;
    background: url("../../assets/images/detail/detail45.jpg") no-repeat center;
    background-attachment: fixed;
    background-size: cover;
    @media (max-width: 768px) {
      li {
        font-size: 12px !important;
        line-height: 18px !important;
      }
      li:after {
        top: 9px !important;
      }
    }
    h3 {
      font-size: 48px;
      color: #fff;
      margin: 4vw 0 2.5vw;
      text-align: left;
      position: relative;
      line-height: 1.8;
      &::after {
        content: "";
        border-bottom: solid 4px #fff;
        width: 120px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        @media (max-width: 768px) {
          width: 100%;
        }
        width: 50%;
        font-size: 20px;
        color: #fff;
        padding-left: 18px;
        position: relative;
        margin-bottom: 1vw;
        &::after {
          content: "";
          width: 8px;
          height: 8px;
          border: solid 2px #fff;
          border-radius: 50%;
          display: block;
          position: absolute;
          left: 0;
          top: 14px;
          margin-top: -4px;
        }
      }
    }
  }
  .content_center_de {
    width: 100%;
    .bottom-p {
      display: flex;
      align-items: center;
      // justify-content: space-between;
      div {
        margin-right: 180px !important;
      }
      @media (max-width: 768px) {
        flex-wrap: wrap;
        div {
          width: 100% !important;
          font-size: 12px !important;
        }
      }
    }
    h3 {
      font-size: 48px;
      color: #ad1f24;
      margin: 4vw 0 2.5vw;
      text-align: left;
      word-wrap: break-all;
      position: relative;
      line-height: 1.8;
      &::after {
        content: "";
        border-bottom: solid 4px #ad1f24;
        width: 120px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    h5 {
      font-size: 36px;
      color: #333;
      margin-top: 5vw;
      padding: 3vw 0 2.5vw;
      text-align: left;
      position: relative;
      line-height: 1.8;
      border-top: solid 1px #d1d2d3;
    }
    h6 {
      font-size: 36px;
      color: #333;
      line-height: 1.8;
      margin-bottom: 3vw;
    }
    .detail45_box {
      margin-top: 3vw;
      .detail45_left {
        .detail45_bottom {
          @media (max-width: 768px) {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .detail45_1 {
            width: 42.5%;
          }
        }
      }
      .detail45_left_pc {
        display: flex;
        justify-content: space-between;
        width: 100%;
        @media (max-width: 768px) {
          display: none !important;
        }
        .detail45_bottom {
          width: 50%;
          margin-top: 30px;

          .detail45_1 {
            width: 42.5%;
          }
        }
        img {
          width: 43% !important;
        }
      }
    }
    .tshu_img_box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      img {
        width: 32%;
        margin-bottom: 3vw;
        &:hover {
          transform: scale(1.1, 1.1);
          transition: all 0.9s ease;
        }
      }
    }
    .sizepic {
      width: 30%;
      display: block;
      margin: auto;
    }
    .note {
      margin: 1vw 0 1vw;
    }
    .Bulk_box {
      font-size: 24px;
      color: #666;
      font-weight: bold;
      @media (max-width: 768px) {
        font-size: 12px !important;
      }
      li {
        padding-left: 1.5vw;
        position: relative;
        &::after {
          content: "";
          width: 1vw;
          height: 1vw;
          background: #666;
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }
    }
    .surfacepic_box {
      margin-top: 3vw;
      display: flex;
      justify-content: space-between;
      border-top: solid 1px #d1d2d3;
      h5 {
        padding: 0;
        border: none;
        margin-top: 2vw;
        margin-bottom: 0.5vw;
        @media (max-width: 768px) {
          font-size: 14px !important;
        }
      }
      .surfacepic {
        width: 31.2%;
      }
      .X2001pic_box {
        width: 65%;
      }
      .X2001pic {
        display: flex;
        justify-content: space-between;
        img {
          width: 48%;
        }
      }
    }
    .btn_content_bottom {
      width: 178px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border: solid 1px #ad1f24;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: pre-wrap;
      @media (max-width: 768px) {
        width: calc(226px / 2) !important;
        height: calc(34px / 2) !important;
        font-size: 9px !important;
        line-height: calc(34px / 2) !important;
        img {
          width: calc(9px / 2) !important;
          height: calc(8px / 2) !important;
        }
      }
      img {
        margin-left: 6px;
      }
      &:hover {
        background: #cfa000;
        color: #fff;
        border: solid 1px #cfa000;
      }
    }
    .product_info1 {
      display: none;
    }

    @media (max-width: 768px) {
      flex-wrap: wrap;
      .left_text {
        width: 100% !important;
      }
      .right_img {
        width: 100% !important;
        // height: 320px !important;
        .top-img {
          height: 320px !important;
        }
      }
      .product_info1 {
        display: block;
        word-wrap: break-word;
        span {
          font-size: 18px !important;
        }
        .overview {
          font-size: 12px !important;
          line-height: 18px !important;
        }
      }
      .product_info {
        display: none;
      }
    }
    .detail_top_box {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      @media (max-width: 768px) {
        flex-wrap: wrap;
        margin-bottom: 20px;
        .left_text {
          width: 100% !important;
        }
        .right_img {
          width: 100% !important;
        }

        .product_info {
          // display: n !important;
        }
      }
      .left_text {
        width: 50%;
        .btn_content_bottom {
          width: 178px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border: solid 1px #ad1f24;
          display: flex;
          align-items: center;
          justify-content: center;
          white-space: pre-wrap;
          img {
            margin-left: 6px;
          }
          &:hover {
            background: #cfa000;
            color: #fff;
            border: solid 1px #cfa000;
          }
        }
      }
      .right_img {
        width: 46%;
        margin-top: 4vw;
        position: relative;
        .swiper-button-next3,
        .swiper-button-prev3 {
          background: #efefef;
          bottom: 0;
          top: auto;
          left: 0;
          width: 5%;
          height: 6.6vw;
          &.swiper-button-disabled {
            opacity: 1;
          }
          &::after {
            content: "prev";
            color: #666666;
            font-size: 2vw;
            font-family: swiper-icons;
          }
          &:hover {
            &::after {
              color: #ad1f24;
            }
          }
        }
        .swiper-button-next3 {
          right: 0;
          left: auto;
          &::after {
            content: "next";
          }
        }
        .mySwiper {
          margin: 1vw auto 0;
          width: 88%;
          .swiper-wrapper {
          }
        }
      }
    }
    .Fabrication_box {
      display: flex;
      .fabrication {
        width: 22%;
        margin-right: 4%;
        background: #efefef;
        position: relative;
        p {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.7);
          text-align: center;
          display: none;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 16px;
        }
        &:hover {
          p {
            display: flex;
          }
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .catid1list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 48%;
        padding: 1vw 3%;
        background: #efefef;
        display: flex;
        align-items: center;
        margin-bottom: 1vw;
        img {
          width: 15%;
          margin-right: 1vw;
        }
        &:hover {
          img {
            animation: jump 0.5s ease-in-out infinite;
          }
        }
      }
    }
    h4 {
      font-size: 20px;
      color: #333;
      margin-bottom: 1vw;
    }
    p {
      font-size: 16px;
      line-height: 2;
      color: #666;
      word-wrap: break-all;
      white-space: pre-wrap;
      span {
        font-weight: bold;
      }

      &.atitle {
        font-size: 20px;
        color: #333;
        font-weight: bold;
        margin-bottom: 2vw;
      }
    }
    td {
      p {
        line-height: inherit;
        word-wrap: inherit;
        white-space: normal;
      }
    }
  }

  .pro_box_a {
    h3 {
      font-size: 48px;
      color: #ad1f24;
      margin: 4vw 0 2.5vw;
      text-align: left;
      position: relative;
      line-height: 1.8;
      &::after {
        content: "";
        border-bottom: solid 4px #ad1f24;
        width: 120px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }

    p {
      font-size: 16px;
      line-height: 2;
      color: #666;
    }
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        width: 49%;
        padding: 2%;
        border: solid 1px #858585;
        margin-bottom: 2.5vw;
        .pro_text {
          font-size: 24px;
          color: #ad1f24;
          margin-bottom: 20px;
          font-weight: bold;
          p {
            font-size: 14px;
            line-height: 1.5;
            margin-top: 20px;
          }
        }
      }
    }
    .swiper-container {
      margin-bottom: 5vw;
      cursor: pointer;
    }
    .swiper-pagination1 {
      text-align: center;
      margin: 1vw 0;
      .swiper-pagination-bullet {
        opacity: 0.5;
        margin: 0 10px;
      }
      .swiper-pagination-bullet-active {
        color: #ad1f24;
        opacity: 1;
      }
    }
    .swiper-button-prev1 {
      width: 121px;
      height: 51px;
      background: url(../../assets/images/cco/cco_aal.png) no-repeat center 100%;
      position: absolute;
      left: 0;
      bottom: 5px;
      &:hover {
        background: url(../../assets/images/cco/cco_aal1.png) no-repeat center
          100%;
      }
    }
    .swiper-button-next1 {
      width: 121px;
      height: 51px;
      background: url(../../assets/images/cco/cco_aar.png) no-repeat center 100%;
      position: absolute;
      right: 0;
      bottom: 5px;
      &:hover {
        background: url(../../assets/images/cco/cco_aar1.png) no-repeat center
          100%;
      }
    }
    @media (max-width: 768px) {
      .container {
        width: 100% !important;
      }
      .custom-title {
        margin-left: 5% !important;
      }
    }
  }

  .content_bottom_a {
    position: relative;

    h3 {
      font-size: 48px;
      color: #ad1f24;
      margin: 4vw 0 2.5vw;
      text-align: left;
      position: relative;
      line-height: 1.8;
      &::after {
        content: "";
        border-bottom: solid 4px #ad1f24;
        width: 120px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    p {
      font-size: 18px;
      color: #333333;
      font-weight: bold;
      span {
        color: #d30000;
      }
    }
    .input_box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      @media (max-width: 768px) {
        li {
          width: 100% !important;
          input {
            height: 30px !important;
            line-height: 30px !important;
          }
        }
      }
      li {
        width: 48%;
        margin-bottom: 2vw;
        input {
          width: 100%;
          background: #efefef;
          border: none;
          outline: none;
          padding: 0 1%;
          height: 50px;
          line-height: 50px;
          &:focus {
            border: solid 1px #ad1f24;
          }
        }
      }
    }
    .checkbox_box {
      ul {
        display: flex;
        margin-bottom: 2vw;
        justify-content: space-between;
        font-size: 16px;
        color: #333;
      }
      @media (max-width: 768px) {
        ul {
          flex-wrap: wrap;
        }
        li {
          display: flex;
          align-items: center;
          width: 100% !important;
          font-size: 12px !important;
          height: 20px;
          input {
            margin-right: 10px;
            margin-top: 0;
          }
        }
      }
    }
    .message_box {
      textarea {
        width: 100%;
        background: #efefef;
        height: 100px;
        border: none;
        outline: none;
        padding: 1%;
        &:focus {
          border: solid 1px #ad1f24;
        }
        @media (max-width: 768px) {
          height: 100px;
        }
      }
    }
    .button_submit {
      font-size: 24px;
      color: #fff;
      line-height: 50px;
      height: 50px;
      width: 100%;
      text-align: center;
      background: #ad1f24;
      margin: 2vw 0 4vw;
      @media (max-width: 768px) {
        height: calc(60px / 2);
        width: calc(662px / 2);
        font-size: 15px !important;
        line-height: calc(60px / 2);
        margin: 10px auto;
      }
    }
  }
  .swiper-slide {
    p {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      overflow: hidden;
      line-height: 2;
      background: rgba(0, 0, 0, 0.7);
      margin-bottom: 0;
      text-align: center;
      color: #fff;
    }
  }
}
</style>
